
import React, { useState, useCallback, useEffect } from 'react';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';
import type { CarouselApi } from '@/components/ui/carousel';
import type { Screenshot } from './types';
import ScreenshotCard from './ScreenshotCard';
import NavigationIndicators from './NavigationIndicators';

interface MobileScreenshotGalleryProps {
  screenshots: Screenshot[];
}

const MobileScreenshotGallery: React.FC<MobileScreenshotGalleryProps> = ({ screenshots }) => {
  const [api, setApi] = useState<CarouselApi>();
  const [currentSlide, setCurrentSlide] = useState(0);

  const onSelect = useCallback((emblaApi: CarouselApi) => {
    if (!emblaApi) return;
    setCurrentSlide(emblaApi.selectedScrollSnap());
  }, []);

  const handleSlideClick = useCallback((index: number) => {
    if (!api) return;
    api.scrollTo(index);
  }, [api]);

  useEffect(() => {
    if (!api) return;
    
    onSelect(api);
    api.on("select", onSelect);
    
    return () => {
      api.off("select", onSelect);
    };
  }, [api, onSelect]);

  return (
    <div className="sm:hidden">
      <Carousel 
        className="w-full" 
        setApi={setApi}
        opts={{
          align: "center",
          loop: false,
          dragFree: true,
        }}
      >
        <CarouselContent className="ml-0">
          {screenshots.map((screenshot, index) => (
            <CarouselItem key={index} className="pl-0 basis-full">
              <div className="px-4">
                <ScreenshotCard 
                  screenshot={screenshot} 
                  isMobile={true}
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      
      <NavigationIndicators 
        totalSlides={screenshots.length} 
        currentSlide={currentSlide}
        onSlideClick={handleSlideClick}
      />
      
      <div className="text-center mt-2">
        <p className="text-xs text-muted-foreground">Swipe to see all features →</p>
      </div>
    </div>
  );
};

export default MobileScreenshotGallery;
